import { render, staticRenderFns } from "./schoolDetail.vue?vue&type=template&id=187ceab2&scoped=true&"
import script from "./schoolDetail.vue?vue&type=script&lang=js&"
export * from "./schoolDetail.vue?vue&type=script&lang=js&"
import style0 from "./schoolDetail.vue?vue&type=style&index=0&id=187ceab2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187ceab2",
  null
  
)

export default component.exports